// 📄 components/common/ChannelProgressBadge.tsx
// Pill de progreso ("1/5", "5/5", "N/A") para las cards de canales de
// integración. Colores por variante siguiendo la paleta ya usada en
// ProjectStatsPanel (azul = en progreso, verde = completo, gris = pendiente).
import React from 'react';

interface ChannelProgressBadgeProps {
  completed: number;
  total: number;
}

type Variant = 'complete' | 'progress' | 'pending' | 'na';

function getVariant(completed: number, total: number): Variant {
  if (total === 0) return 'na';
  if (completed === 0) return 'pending';
  if (completed >= total) return 'complete';
  return 'progress';
}

const VARIANT_CLASSES: Record<Variant, string> = {
  complete: 'bg-emerald-500/15 text-emerald-400',
  progress: 'bg-blue-500/15 text-blue-400',
  pending: 'bg-white/10 text-gray-400',
  na: 'bg-white/10 text-gray-500'
};

export default function ChannelProgressBadge({ completed, total }: ChannelProgressBadgeProps) {
  const variant = getVariant(completed, total);
  const label = variant === 'na' ? 'N/A' : `${completed}/${total}`;

  return (
    <span className={`text-[11px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${VARIANT_CLASSES[variant]}`}>
      {label}
    </span>
  );
}
